<!-- Header Start -->
<section class="cyclops header" id="home">
  <div class="cyclops-header bg video-header">
    
    <!-- Background video -->
    <video class="video-bg" autoplay muted loop playsinline>
      <source src="assets/images/headervideo.mp4" type="video/mp4" />
      Your browser does not support the video tag.
    </video>

    <!-- Dark overlay -->
    <div class="video-dark-overlay" aria-hidden="true"></div>

    <!-- Content overlay -->
    <div class="video-overlay">
      <div class="container h-100 d-flex align-items-center">
        <div class="row w-100">
          <div class="col-12 col-md-10 mx-auto text-center">
            
            <!-- Main Heading -->
            <h1 class="header-title">
              <span class="bold-text">Above all . Beyond Limits</span>
            </h1>
 
            <!-- Sub Heading -->
            <p class="header-description">
              Delivering precision defense and security solutions for the missions that matter most.
            </p>

            <!-- Watch Video Button -->
            <a href="#solutions" 
               class="watch-video-btn">
              Explore solutions <span class="circle-arrow">→</span>
            </a>

          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- Header End -->
